import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';

import { retry, tap } from 'rxjs/operators';



import { ErrorsService } from '../errors-service/errors.service';

import { Observable } from "rxjs/";

@Injectable()
export class ServerErrorsInterceptor implements HttpInterceptor {
  constructor(
    private errorsService: ErrorsService
  ) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(retry(0), tap((event: HttpEvent<any>) => { }, (err: any) => {
      if (err instanceof HttpErrorResponse) {
        this.errorsService.toastrLog(err);
      }
    }));

  }
}
